import Cover from '@/components/cover';
import { ISpace } from '@/interface';
import { getMediaUrlValue } from '@/material/form-upload/change-data';

import styles from './index.module.less';

interface SpaceCardProps {
  data: Partial<ISpace>;
  style?: React.CSSProperties;
}

export const SpaceCard = (props: SpaceCardProps) => {
  const { name, intro, bannerUrl } = props.data || {};
  const url = getMediaUrlValue(bannerUrl);
  return (
    <div className={styles.card}>
      <Cover
        width="200"
        height="100"
        {...props}
        src={url}
        className={styles.cover}
      >
        <div className={styles.text}>
          <div className={styles.title}>{name}</div>
          {intro ? <div className={styles.desc}>{intro}</div> : null}
        </div>
      </Cover>
    </div>
  );
};
